import { useState, useEffect, useCallback } from 'react'
import { getAgents, getDefaultAgent } from 'services/ai_agent'

export interface Agent {
  id: string
  slug: string
  name: string
  instructions?: string
  is_default?: boolean
}

export function useAgents() {
  const [agents, setAgents] = useState<Agent[]>([])
  const [selectedAgent, setSelectedAgent] = useState<Agent | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)

    Promise.all([getAgents(), getDefaultAgent()])
      .then(([agentsRes, defaultRes]) => {
        if (cancelled) return

        const agentList: Agent[] = agentsRes.data ?? []
        setAgents(agentList)

        // Pre-select the default agent
        const defaultAgent: Agent | null = defaultRes.data ?? null
        if (defaultAgent) {
          setSelectedAgent(defaultAgent)
        } else if (agentList.length > 0) {
          setSelectedAgent(agentList[0])
        }
      })
      .catch((err) => {
        console.error('[useAgents] Failed to load agents:', err)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const selectAgent = useCallback((agentSlug: string) => {
    const agent = agents.find((a) => a.slug === agentSlug) ?? null
    setSelectedAgent(agent)
  }, [agents])

  return { agents, selectedAgent, selectAgent, isLoading }
}
